angular
	.module('inputCf.components', [])
	.component('inputCf', {
		templateUrl: 'ng/components/inputCf/inputCf.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			formName: '=',
			bindingVariable: '=',
			inputPlaceholder: '@',
			onBlurFunc: '<',
			/** Optional data **/
			inputDisableOn: '<',
			isRequired: '<',
			onChange: '&?',
			elementToDisable: '@',
			checkWholeForm: '@'
		},
		controllerAs: 'inputCfCtrl',
		controller: function ($translate, validationService) {
			/** not to loose *this reference **/
			var self = this;

			/** import services */
			self.validationService = validationService;

			/** init viariables */
			self.errorMsgShown = false;
			self.valid = true;

			self.$onInit = function () {
				self.inputDisableOn = self.inputDisableOn || false;
				self.isRequired = self.isRequired !== false;
			}

			self.$postLink = function () {
				console.log('inputCf::postLink');
			}

			self.$doCheck = function () {
				console.log('inputCf::doCheck');
			}

			self.$onChanges = function () { }

			self.resetAlert = function () {
				self.errorMsgShown = false;
			}

			self.showAlertMsg = function () {
				self.errorMsgShown = !self.errorMsgShown;
				console.log("il cf non è corretto");
			}

			self.checkCf = function (cf, form, inputName) {
				return true;
				/*
				if (cf) {
					if (validationService.isValidCf(cf[0])) {
						form[inputName].$invalid = false;
						form[inputName].$setValidity('cf', true);
						form[inputName].$valid = true;
						self.valid = true;

					} else {

						cf = cf.toUpperCase();
						if (cf == '') return '';
						if (!validationService.isValidCf(cf)) {
							form[inputName].$invalid = true;
							form[inputName].$setValidity('cf', false);
							form[inputName].$valid = false;
							self.valid = false;
							return false;
						}
						var map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17,
							19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23
						];
						var s = 0;
						for (var i = 0; i < 15; i++) {
							var c = cf.charCodeAt(i);
							if (c < 65)
								c = c - 48;
							else
								c = c - 55;
							if (i % 2 == 0)
								s += map[c];
							else
								s += c < 10 ? c : c - 10;
						}
						var atteso = String.fromCharCode(65 + s % 26);
						if (atteso != cf.charAt(15)) {
							form[inputName].$invalid = true;
							form[inputName].$setValidity('cf', false);
							form[inputName].$valid = false;
							self.valid = false;
							return false;
						}

						form[inputName].$invalid = false;
						form[inputName].$setValidity('cf', true);
						form[inputName].$valid = true;
						self.valid = true;
						return true;


					}
				} else {
					if (form && inputName) {
						form[inputName].$invalid = false;
						form[inputName].$setValidity('cf', true);
						form[inputName].$valid = true;
						self.valid = true;
					}

					self.valid = false;
					return false;
					 }
					 */
				}
				

			}
		});